// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SellerReviews__selfBlocked":"gu_a big_ea big_va big_ts big_vm big_vh"};